import React from 'react'

type DonutChartProps = React.SVGProps<SVGSVGElement>

const DonutChart = React.forwardRef<SVGSVGElement, DonutChartProps>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="M9.29712 0.0192871L9.29722 2.97255C5.98153 3.44682 3.43273 6.29834 3.43273 9.74513C3.43273 13.5238 6.49596 16.587 10.2746 16.587C11.8114 16.587 13.2299 16.0803 14.3721 15.2249L16.4606 17.3131C14.7756 18.692 12.6218 19.5193 10.2746 19.5193C4.87652 19.5193 0.500488 15.1433 0.500488 9.74513C0.500488 4.67696 4.35797 0.509725 9.29712 0.0192871ZM20.0005 10.7226C19.8053 12.6882 19.0279 14.4825 17.843 15.9305L15.7544 13.8427C16.4251 12.9471 16.8815 11.8818 17.0472 10.7225L20.0005 10.7226ZM11.2531 0.019385C15.8703 0.478311 19.542 4.15034 20.0005 8.76762L17.0472 8.76752C16.6185 5.77151 14.2489 3.40166 11.253 2.97268L11.2531 0.019385Z" />
      </svg>
    )
  },
)
DonutChart.displayName = 'DonutChart'

export { DonutChart, type DonutChartProps }
